import React from 'react';

import cs from 'classnames';

import {ListMessage} from 'app/components/general/ListMessage';
import {getDescriptionContent} from 'app/components/VersionDiffer';
import {DocumentFoldersList} from 'app/folders/components/DocumentFoldersList';
import {ViewStepsModeTitle} from 'app/general/detailpage/ViewStepsModeTitle';
import {DocHeaderStructure} from 'app/general/structures/DocHeader';
import MetaContentTypeName from 'app/general/structures/MetaContentTypeName';
import {UserContentContainer} from 'app/general/structures/UserContentContainer';
import {DocumentPolicyList} from 'app/policies/components/DocumentPolicyList';
import {StyledStepsListDIV} from 'app/procedures/components/structures';
import {ViewableChoices} from 'app/procedures/components/ViewableChoices';
import {useProcessByHashid} from 'app/process/api';
import {NextStepLinkItem} from 'app/steps/components/NextStepLinkItem';
import {DocumentTagsList} from 'app/tags/components/DocumentTagsList';
import {getProcessName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';
import {isRightToLeftWrapper} from 'app/utils/rtl';

import {TemplateProcessStep} from './TemplateProcedureStep';

import {useTemplate} from '../context';

export function TemplateProcessDetail() {
  const template = useTemplate();
  const {data: process} = useProcessByHashid(template.document_hashid);

  if (process == null) {
    return null;
  }

  const content = {
    name: process.name,
    url: process.url,
    html_url: process.html_url,
    description: process.description,
    content: process.content,
    lanes: process.lanes,
  };

  const processTitle =
    typeof content.name === 'string'
      ? getProcessName(content, true)
      : content.name;

  return (
    <>
      <DocHeaderStructure
        thumbnail={process.thumbnail}
        advancedContent={<MetaContentTypeName contentType={'proceduregroup'} />}
        tagsContent={
          <>
            <DocumentTagsList tags={process.tags} />
            <DocumentFoldersList connections={process.connections} />
          </>
        }
        titleContent={
          <h1
            className={cs('fr-view', {
              'right-to-left-text': isRightToLeftWrapper(content.name),
            })}
          >
            <UserContentContainer content={processTitle} />
          </h1>
        }
        policyContent={<DocumentPolicyList policies={process.policies} />}
        descriptionContent={
          <UserContentContainer
            content={getDescriptionContent(content.description)}
          />
        }
      />
      <StyledStepsListDIV className="js-document-body container pt-0">
        <div className="row">
          <div className="pt-4 col-12">
            <ViewStepsModeTitle title={gt('Procedures List')} />
            <ol className="steps">
              {content.content.map((step, index) => (
                <li key={index} id={step.id}>
                  <TemplateProcessStep
                    index={index}
                    step={step}
                    objectId={process.id}
                    lanes={content.lanes}
                    choicesList={
                      step.type === 'decision' ? (
                        <ViewableChoices
                          choices={step.choices}
                          steps={content.content}
                          edit={true}
                        />
                      ) : null
                    }
                    next={
                      <NextStepLinkItem step={step} steps={content.content} />
                    }
                  />
                </li>
              ))}
            </ol>

            {content.content.length === 0 ? (
              <ListMessage gray={true}>
                {gt('No steps for this process')}
              </ListMessage>
            ) : null}
          </div>
        </div>
      </StyledStepsListDIV>
    </>
  );
}
